import { render } from "./ModalAttack.vue?vue&type=template&id=3d9df10c&scoped=true"
import script from "./ModalAttack.vue?vue&type=script&lang=ts"
export * from "./ModalAttack.vue?vue&type=script&lang=ts"

import "./ModalAttack.vue?vue&type=style&index=0&id=3d9df10c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3d9df10c"

export default script